import React, { useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import {
    responseGet, globalSettings, styles, validateEmail, validatePhoneNumber, sendMessageCloseCurrentWindowAsync, buttonProcessGet, languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';
import { apartmentPeopleModelGet } from '../../models/apartments/apartmentPeople';
import { peopleTypeModelGet } from '../../models/peopleTypes/peopleType';

const currentMethod = 'ApartmentPeopleAddEditDetails';

const { app, icons, images, labels, messages, } = globalSettings;
const { backend, } = app;
//const { html: reactHtml, } = react;
//const { properties: dbProps, } = dbColle;

export default function ApartmentPeopleAddEditDetails({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    apartmentPeople = apartmentPeopleModelGet({}),
    setApartmentPeople = () => { },
    peopleTypes = [peopleTypeModelGet({})],
    peopleTypeGet = ({ peopleTypeId = {}, peopleTypes = [], subMethod = '', }) => { },
    dtId = '',
    dtRowIndex = 0,
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [firstNameError, setFirstNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [peopleTypeError, setPeopleTypeError] = useState('');
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnModalApartmentPeopleAddEditDetailsSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnModalApartmentPeopleAddEditDetailsBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalApartmentPeopleAddEditDetailsClose',
            },
        },
        checkBox: {
            // topLevel: {
            //     id: 'chkTopLevel',
            //     className: 'icheck-primary',
            // },
            // lowLevel: {
            //     id: 'chkLowLevel',
            //     className: 'icheck-primary',
            // }
        },
        dataTables: {
            // apartmentUsers: {
            //     buttons: {
            //         add: {
            //             id: 'btnApartmentuserAdd',
            //             className: 'btn btn-outline-success float-right btn-sm',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icoApartmentuserAdd',
            //             className: icons?.plusCircle,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtApartmentUsersId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtApartmentUsersId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spApartmentuserAdd',
            //             className: '',
            //         },
            //     },
            // },
            // apartmentPeoples: {
            //     buttons: {
            //         add: {
            //             id: 'btnApartmentPeoplesAdd',
            //             className: 'btn btn-outline-success float-right btn-sm',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icoApartmentPeoplesAdd',
            //             className: icons?.plusCircle,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtApartmentPeoplesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtApartmentPeoplesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spApartmentPeoplesAdd',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoModalApartmentPeopleAddEditDetailsSave',
                className: icons?.save,
            },
            back: {
                id: 'icoModalApartmentPeopleAddEditDetailsBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoModalApartmentPeopleAddEditDetailsClose',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            firstName: {
                id: 'inputModalApartmentPeopleAddEditDetailsFirstName',
                className: 'form-control',
            },
            lastName: {
                id: 'inputModalApartmentPeopleAddEditDetailsLastName',
                className: 'form-control',
            },
            phoneNumber: {
                id: 'inputModalApartmentPeopleAddEditDetailsPhoneNumber',
                className: 'form-control',
            },
            email: {
                id: 'inputModalApartmentPeopleAddEditDetailsEmail',
                className: 'form-control',
            },
        },
        selects: {
            peopleType: {
                id: 'selModalApartmentPeopleAddEditDetailsPeopleType',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spModalApartmentPeopleAddEditDetailsSave',
                className: '',
            },
            back: {
                id: 'spModalApartmentPeopleAddEditDetailsBack',
                className: '',
            },
            close: {
                id: 'spModalApartmentPeopleAddEditDetailsClose',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                await errosDefaultSetAsync({ subMethod: currentMethod, });

                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });

                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                setShowModal(!isModalClose);
            }
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setApartmentPeople({ ...apartmentPeople, [property]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: apartmentPeople?.firstName, subMethod: currentMethod, })?.result) {
                setFirstNameError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: apartmentPeople?.lastName, subMethod: currentMethod, })?.result) {
                setLastNameError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: apartmentPeople?.phoneNumber, subMethod: currentMethod, })?.result && !validatePhoneNumber({ phoneNumber: apartmentPeople?.phoneNumber, })) {
                setPhoneNumberError(messages?.youMustEnterValidPhoneNumber?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: apartmentPeople?.email, subMethod: currentMethod, })?.result && !validateEmail({ email: apartmentPeople?.email })) {
                setEmailError(messages?.youMustEnterValidEmail?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: apartmentPeople?.peopleTypeId, subMethod: currentMethod, })?.result) {
                setPeopleTypeError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        let response = responseGet();
        try {
            setEmailError('');
            setLastNameError('');
            setFirstNameError('');
            setPeopleTypeError('');
            setPhoneNumberError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const apartmentPeopleAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentPeopleAddPostAsync';
        let response = responseGet();
        try {
            //#region initialize
            e?.preventDefault();

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data save
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartmentPeople: apartmentPeople,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentPeoples}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const ap = response.result; //apartmentPeople

            $(`#${dtId}`)?.DataTable()?.row?.add([
                ap?.firstName,
                ap?.lastName,
                peopleTypeGet({
                    peopleTypeId: ap?.peopleTypeId,
                    peopleTypes: peopleTypes,
                    subMethod: currentMethod,
                })?.result,
                buttonProcessGet({
                    id: ap?.id,
                    description: `${ap?.firstName || ''}, ${ap?.lastName || ''}`,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            //#endregion data save
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const apartmentPeopleEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentPeopleEditPostAsync';
        let response = responseGet();
        try {
            //#region initialize
            e?.preventDefault();

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data save
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartmentPeople: apartmentPeople,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentPeoples}/${apartmentPeople?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const apartmentPeopleLocal = response?.result;

            $(`#${dtId}`)?.DataTable()?.row(dtRowIndex)?.data?.([
                apartmentPeopleLocal?.firstName,
                apartmentPeopleLocal?.lastName,
                peopleTypeGet({
                    peopleTypeId: apartmentPeopleLocal?.peopleTypeId,
                    peopleTypes: peopleTypes,
                    subMethod: currentMethod,
                })?.result,
                buttonProcessGet({
                    id: apartmentPeopleLocal?.id,
                    description: `${apartmentPeopleLocal?.firstName}, ${apartmentPeopleLocal?.lastName}`,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#endregion data save

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.buttons?.close?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save?.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.buttons?.close?.id}`)?.addClass(controls?.buttons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            $(`#${controls?.inputs?.firstName?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.lastName?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.phoneNumber?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.peopleType?.id}`).attr('disabled', (processType !== 0));

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTables
            // $(`#${controls?.dataTables?.apartmentUsers?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.apartmentUsers?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            // $(`#${controls?.dataTables?.apartmentPeoples?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.apartmentPeoples?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTables

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.occupant?.[languageObj?.id]}
                        src={images?.familyLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.occupant?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    //className='close btn-danger fas fa-window-close'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnHeader', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ? apartmentPeopleAddPostAsync({ e: e, subMethod: 'form - onSubmit' }) : processType === 1 ? apartmentPeopleEditPostAsync({ e: e, subMethod: 'form - onSubmit', }) : e?.preventDefault()}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processType === 0 ? apartmentPeopleAddPostAsync(e) : processType === 1 ? apartmentPeopleEditPostAsync(e) : e?.preventDefault()}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.occupant?.[languageObj?.id]} src={images?.familyLogo} style={styles?.cardHeaderLogo}></img> - {labels?.occupant?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* Body */}
                    {/* <div className='card-body'> */}
                    {processType !== 2 ?
                        <div>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.firstName?.id}
                                        //autoFocus
                                        className={controls?.inputs?.firstName?.className}
                                        placeholder={labels?.firstName?.[languageObj?.id]}
                                        onChange={(e) => formDataSetAsync({ property: 'firstName', value: e?.target?.value, subMethod: 'input - firstName', })}
                                        onFocus={() => setFirstNameError('')}
                                        value={apartmentPeople?.firstName || ''}
                                        tooltip='tooltip' title={labels?.firstName?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className='fas fa-user' />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(firstNameError)}</div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.lastName?.id}
                                        className={controls?.inputs?.lastName?.className}
                                        placeholder={labels?.lastName?.[languageObj?.id]}
                                        onChange={(e) => formDataSetAsync({ property: 'lastName', value: e?.target?.value, subMethod: 'input - lastName', })}
                                        onFocus={() => setLastNameError('')}
                                        value={apartmentPeople?.lastName || ''}
                                        tooltip='tooltip' title={labels?.lastName?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className='fas fa-user' />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(lastNameError)}</div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.phoneNumber?.id}
                                        className={controls?.inputs?.phoneNumber?.className}
                                        placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                        onChange={(e) => formDataSetAsync({ property: 'phoneNumber', value: e?.target?.value, subMethod: 'input - phoneNumber', })}
                                        onFocus={() => setPhoneNumberError('')}
                                        value={apartmentPeople?.phoneNumber || ''}
                                        tooltip='tooltip' title={labels?.phoneNumber?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className='fas fa-mobile-alt' />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(phoneNumberError)}</div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.email?.id}
                                        className={controls?.inputs?.email?.className}
                                        placeholder={labels?.email?.[languageObj?.id]}
                                        onChange={(e) => formDataSetAsync({ property: 'email', value: e?.target?.value, subMethod: 'input - email', })}
                                        onFocus={() => setEmailError('')}
                                        value={apartmentPeople?.email || ''}
                                        tooltip='tooltip' title={labels?.email?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.envelope} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(emailError)}</div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <select id={controls?.selects?.peopleType?.id}
                                        className={controls?.selects?.peopleType?.className}
                                        defaultValue={apartmentPeople?.peopleTypeId || ''}
                                        onChange={(e) => formDataSetAsync({ property: 'peopleTypeId', value: e?.target?.value, subMethod: 'input - peopleTypeId', })}
                                        onFocus={() => setPeopleTypeError('')}
                                        placeholder={labels?.peopleType?.[languageObj?.id]}
                                        tooltip='tooltip' title={labels?.peopleType?.[languageObj?.id]}>
                                        <option value=''>{messages?.selectPeopleType}</option>
                                        {peopleTypes?.map((detail) => <option key={detail?.id} value={detail?.id}>{detail?.description}</option>)}
                                    </select>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.envelope} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(peopleTypeError)}</div>
                            </div>
                        </div>
                        :
                        <div className='text-muted'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.firstName?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {apartmentPeople?.firstName || ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.lastName?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {apartmentPeople?.lastName || ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.phone?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {apartmentPeople?.phoneNumber || ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.email?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {apartmentPeople?.email || ''}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <b>{labels?.peopleType?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: apartmentPeople?.peopleTypeId, subMethod: 'label - peopleType' })?.result ?
                                        (peopleTypes?.find(({ id, }) => id === apartmentPeople?.peopleTypeId)?.description || '') : ''}
                                </div>
                            </div>
                        </div>
                    }
                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                {processType !== 2 ?
                                    <button className='btn btn-outline-warning mx-1'
                                        tooltip='tooltip'
                                        title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                        type='submit'>
                                        <i className={icons?.save}></i>
                                    </button>
                                    :
                                    <></>
                                }
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset' onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        {processType !== 2 ?
                            <button id={controls?.buttons?.save?.id}
                                className={controls?.buttons?.save?.className}
                                tooltip='tooltip'
                                title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                type='submit'>
                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                            </button>
                            :
                            <></>
                        }
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset' onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnFooter', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal >
    )
}